import store from "app/redux/store/store";
import { IColuna } from "app/types/IColuna";
import { IOrcamento } from "app/types/IOrcamento";

export function obterColunasEstoquesFiliais(orcamento: IOrcamento) : IColuna[] {
    const colunasRedux = store.getState().colunasGridOrcamento
    
    return ((orcamento.ItensOrcamento ?? [])[0]?.ListEstoqueProduto?.Estoques ?? []).map(e => ({
        Codigo: -1,
        Nome: `F${e.CodigoFilial}`,
        Permitido: colunasRedux.find(c => c.Nome == `F${e.CodigoFilial}`) != null ?  colunasRedux.find(c => c.Nome == `F${e.CodigoFilial}`).Permitido : true, 
        Selecionada: colunasRedux.find(c => c.Nome == `F${e.CodigoFilial}`) != null ?  colunasRedux.find(c => c.Nome == `F${e.CodigoFilial}`).Selecionada : true,
        ehEstoqueFilial: true
    } as IColuna))
}